'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const heyListen_es = require('../../../../../hey-listen/dist/hey-listen.es.js');
require('../../../../../popmotion/dist/es/utils/clamp.js');
require('../../../../../popmotion/dist/es/animations/generators/spring.js');
require('../../../../../popmotion/dist/es/utils/progress.js');
require('../../../../../popmotion/dist/es/utils/mix.js');
require('../../../../../popmotion/dist/es/utils/mix-color.js');
require('../../../../../popmotion/dist/es/utils/pipe.js');
require('../../../../../popmotion/dist/es/utils/mix-complex.js');
require('../../../../../popmotion/dist/es/utils/interpolate.js');
require('../../../../../popmotion/dist/es/easing/utils.js');
const index = require('../../../../../popmotion/dist/es/easing/index.js');
require('../../../../../popmotion/dist/es/animations/generators/keyframes.js');
require('../../../../../popmotion/dist/es/animations/generators/decay.js');
require('../../../../../popmotion/dist/es/animations/index.js');
require('../../../../../popmotion/dist/es/utils/velocity-per-second.js');
require('../../../../../popmotion/dist/es/animations/inertia.js');
require('../../../../../popmotion/dist/es/utils/is-point.js');
require('../../../../../popmotion/dist/es/utils/is-point-3d.js');
require('../../../../../popmotion/dist/es/utils/distance.js');
const cubicBezier = require('../../../../../popmotion/dist/es/easing/cubic-bezier.js');

var easingLookup = {
  linear: index.linear,
  easeIn: index.easeIn,
  easeInOut: index.easeInOut,
  easeOut: index.easeOut,
  circIn: index.circIn,
  circInOut: index.circInOut,
  circOut: index.circOut,
  backIn: index.backIn,
  backInOut: index.backInOut,
  backOut: index.backOut,
  anticipate: index.anticipate,
  bounceIn: index.bounceIn,
  bounceInOut: index.bounceInOut,
  bounceOut: index.bounceOut
};
var easingDefinitionToFunction = function (definition) {
  if (Array.isArray(definition)) {
    // If cubic bezier definition, create bezier curve
    heyListen_es.invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var _a = tslib.__read(definition, 4),
      x1 = _a[0],
      y1 = _a[1],
      x2 = _a[2],
      y2 = _a[3];
    return cubicBezier.cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    // Else lookup from table
    heyListen_es.invariant(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
    return easingLookup[definition];
  }
  return definition;
};
var isEasingArray = function (ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};

exports.easingDefinitionToFunction = easingDefinitionToFunction;
exports.isEasingArray = isEasingArray;
